import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  MIME_TYPES,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { apiCall } from '../../services';

const ENDPOINT = `${APIConfiguration.document}upload/attachments/session`;

export enum SessionType {
  SINGLE_FILE = 'SingleFile',
  MULTI_FILES = 'MultiFiles',
}

export interface GetFilesUploadLinksBySessionIdCommandArgs {
  sellerId?: string;
  type?: SessionType;
  allowedMimeTypes?: MIME_TYPES[];
  metaData?: Record<any, any>;
}

export interface FileAttachmentUploadLink {
  uploadUrl: string;
  uploadQrCode: string;
  sessionId: string;
}

async function getFilesUploadLinksBySessionIdCommand({
  sellerId,
  type,
  allowedMimeTypes,
  metaData,
}: GetFilesUploadLinksBySessionIdCommandArgs = {}): Promise<
  BackResponse<FileAttachmentUploadLink> | BackResponseFailure
> {
  try {
    return await apiCall<BackResponse<FileAttachmentUploadLink>>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        sellerId,
        type,
        allowedMimeTypes,
        metaData: JSON.stringify(metaData),
      },
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default getFilesUploadLinksBySessionIdCommand;
